<script setup lang="ts">
import { computed } from 'vue'
import { Star, Badge, Check } from 'lucide-vue-next'

interface Props {
  kind: 'preferred' | 'partner'
}

const props = defineProps<Props>()

const label = computed(() => {
  return props.kind === 'preferred' ? 'Preferred' : 'Avee Partner'
})
</script>

<template>
  <span class="inline-flex items-center gap-1.5 p-1 text-xs font-semibold text-gray-500 border border-gray-200 rounded-md grow-0 w-fit">
    <Star v-if="kind === 'preferred'" class="w-4 h-4 fill-yellow-400 stroke-yellow-600" />
    <div v-else-if="kind === 'partner'" class="relative w-4 h-4">
      <Badge class="w-4 h-4 fill-emerald-600 stroke-emerald-600" />
      <Check class="absolute top-2 left-2 -translate-x-1/2 -translate-y-1/2 w-2.5 h-2.5 stroke-white stroke-3" stroke-width="4" />
    </div>
    {{ label }}
  </span>
</template>